import React, { useState } from "react";
import {
  RenderSvg,
  baseUrl,
  handleCopy,
} from "../../../../../utils/helpers/helper";
import { Img } from "react-image";
import { Link } from "gatsby";
import bgVideo from "../../../../../images/backgroundVideos/greybg.mp4";
import RenderMedia from "../../../../../components/Images";
import { SecondarySquareCardLayout } from "../../../../../components/layoutSections/LayoutSection";
import { Popup } from "../../../../../components/popup";
import { PrimarySquareCard } from "../../../../../components/cards/Cards";

export default function AfterContent({ blog, blog_tags, styles }) {
  const { author, blogTitle, pdf, otherblogs, readTime } = blog || {};
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {author && (
        <Author
          author={author}
          blogTitle={blogTitle}
          pdf={pdf}
          styles={styles}
        />
      )}
      {blog_tags?.length > 0 && (
        <div
          className={`${styles?.blogSingleContentCategoryWrap} desktop-hide`}
          style={{
            width: "90%",
            margin: "0 auto",
            paddingBottom: "0",
            gap: "15px",
            padding: "15px 0",
            flexDirection: "row",
          }}
        >
          {blog_tags?.map((data, index) => {
            const { tag, slug } = data;
            return (
              <Link
                to={"/resources/blogs?tag=" + slug}
                className={styles?.blogSingleContentCategory}
                key={index}
              >
                {tag}
              </Link>
            );
          })}
        </div>
      )}
      {otherblogs?.length > 0 && (
        <OtherBlogs blogs={otherblogs} styles={styles} />
      )}
    </div>
  );
}

const Author = ({ author, blogTitle, pdf, styles }) => {
  const { authorProfile, slug } = author || {};
  const [copied, setCopied] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  return (
    <>
      {copied && <div className="showCopied"> Link Copied</div>}
      <div className={styles?.AfterContentContainer}>
        <div className={styles?.AfterContentAuthor}>
          <Link
            className={styles?.AfterContentAuthorLink}
            to={"/author/" + slug}
          >
            <Img
              style={{ width: "100%", height: "100%" }}
              src={baseUrl + authorProfile?.url}
              alt={authorProfile?.name}
            />
          </Link>
          <div className={styles?.authorProfileContent}>
            <div>
              <h3>{author?.Name}</h3>
            </div>
            <div>
              <p>{author?.designation}</p>
            </div>
            {!author?.Name?.includes("Team") && (
              <div className={styles?.authorSocailMedia}>
                {author?.socialLinks?.map((e, index) => {
                  return (
                    <a key={index} href={e.url} target={"_blank"}>
                      <RenderSvg
                        IconName={e.label}
                        IconType={"brands"}
                        style={{ height: "20px", color: "white" }}
                      />
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className={styles?.AfterContentAuthorLinkIcons}>
          <div className={styles?.AfterContentIcons}>
            {/* <div>
              <button
                onClick={() =>
                  handleCopy({
                    onSuccess: () => {
                      setCopied(true);
                      setTimeout(() => {
                        setCopied(false);
                      }, 1500);
                    },
                  })
                }
              >
                <span>
                  <RenderSvg IconName={"link"} style={{ height: "25px" }} />
                </span>
              </button>
            </div> */}

            {pdf?.PdfFile && (
              <div>
                <a
                  href={baseUrl + pdf?.PdfFile?.url}
                  target={"_blank"}
                  download={true}
                >
                  <span>
                    <RenderSvg
                      IconName={"arrow-to-bottom"}
                      style={{ height: "25px" }}
                    />
                  </span>
                </a>
              </div>
            )}

            <div>
              <button onClick={() => setOpenPopup(true)}>
                <span>
                  <RenderSvg
                    IconName={"share-alt"}
                    style={{ height: "25px" }}
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} share />
    </>
  );
};

const OtherBlogs = ({ blogs, styles }) => {
  return (
    <>
      <div className={styles?.OtherBlogsContainer}>
        <video
          autoPlay
          loop
          muted
          playsInline
          controls={false}
          className={styles?.bgVideo}
        >
          <source src={bgVideo} type="video/mp4" />
        </video>
        <div className={styles?.OtherBlogsContainerItem}>
          <h2 className="heading-quaternary-lg fw-500">Other Blogs</h2>
          <div className={styles?.OtherBlogsWrap}>
            {blogs?.map((data, index) => {
              const {
                blogTitle,
                readTime,
                DesktopvideoId,
                mobileVideoId,
                DesktopMedia,
                blog_category,
              } = data;
              const media =
                DesktopMedia?.localFile?.childImageSharp?.gatsbyImageData;
              return (
                <React.Fragment key={index}>
                  <div className={styles?.mobileBlogs}>
                    <SecondarySquareCardLayout
                      to={`/resources/blogs/${blogTitle?.replaceAll(" ", "-")}`}
                      title={blogTitle}
                      showMinute={readTime || "5 min"}
                      tagText={blog_category?.categoryName}
                      image={
                        media
                          ? { gatsbyImageData: media }
                          : { mediaName: "blogImg.jpg" }
                      }
                    />
                  </div>
                  <div className={styles?.desktopBlogs}>
                    <PrimarySquareCard
                      to={`/resources/blogs/${blogTitle?.replaceAll(" ", "-")}`}
                      title={blogTitle}
                      showMinute={true}
                      tagText={blog_category?.categoryName}
                      image={
                        media
                          ? { gatsbyImageData: media }
                          : { mediaName: "blogImg.jpg" }
                      }
                    />
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
